import { Component } from '@angular/core';

@Component({
  selector: 'app-clock-icon',
  templateUrl: './clock-icon.component.html',
  styleUrl: './clock-icon.component.scss'
})
export class ClockIconComponent {

}
